import { Button as ButtonComponent } from 'components';
import styled from 'styled-components';

export const Button = styled(ButtonComponent)`
  width: 96px;
  height: 37px;
`;
